<template>
  <ul class="title-description-list__wrapper">
    <li
      v-for="item in items"
      :key="item.title"
      class="title-description-list__item"
    >
      <h3 class="title-description-list__item-title">
        <slot name="title" :title="item.title">
          {{ item.title }}
        </slot>
      </h3>
      <p class="title-description-list__item-description">
        <slot name="description" :description="item.description">
          {{ item.description }}
        </slot>
      </p>
    </li>
  </ul>
</template>

<script>
import { PROP_TYPES, propValidator } from '@fmpedia/validators'

export default {
  name: 'TitleDescriptionList',
  props: {
    items: propValidator([PROP_TYPES.ARRAY])
  }
}
</script>

<style lang="scss" scoped>
.title-description-list__wrapper {
  .title-description-list__item-title {
    margin-bottom: 8px;
  }

  .title-description-list__item-description {
    color: $c--text-secondary;
  }
}
</style>
